import React from 'react';

const WaveDiv = () => {
  return (
    <div className="wave-container">
      <div className="wave"></div>
    </div>
  );
};

export default WaveDiv;
